export const isDisplayableValue = (val) => !!val && ['string', 'number'].includes(typeof val);
